import { PublicTimesheetView } from '@/shared/types/public-timesheet';

/**
 * Mock de la page publique « Valider le CRA » (mode `NEXT_PUBLIC_API_IMPL=mock`).
 *
 * Tokens de test reconnus :
 *  - `invalid`   → 404 (lien invalide)
 *  - `expired`   → 400 « Ce lien a expiré »
 *  - `approved` / `rejected` → lien déjà consommé (decided:true)
 *  - tout autre token → CRA PENDING, la décision est mémorisée en mémoire
 *    (persiste jusqu'au rechargement de la page).
 */
const baseTimesheet: PublicTimesheetView = {
  consultantName: 'Beauclair BILONG',
  missionLabel: 'Renault — Développeur AEM',
  monthLabel: 'Juin',
  year: 2026,
  month: 6,
  workedDays: 22,
  absenceDays: 0,
  workingDays: 22,
  onCallMinutes: 1080,
  onCall: [
    { type: 'Nuit', count: 2, minutes: 600 },
    { type: 'Week-end', count: 1, minutes: 480 },
  ],
  onCallEntries: [
    { date: '2026-06-12', type: 'Nuit', minutes: 300, detail: 'Incident production' },
    { date: '2026-06-15', type: 'Week-end', minutes: 480 },
    { date: '2026-06-22', type: 'Nuit', minutes: 300 },
  ],
  comment: 'CRA 2026-06 — mission réalisée conformément au planning.',
  validatorName: 'Nicolas Perrin',
  status: 'PENDING',
  decided: false,
};

// État en mémoire, muté par les décisions (reset au reload).
const store = new Map<string, PublicTimesheetView>();

function seed(token: string): PublicTimesheetView {
  if (token === 'approved') {
    return { ...baseTimesheet, status: 'APPROVED', decided: true };
  }
  if (token === 'rejected') {
    return { ...baseTimesheet, status: 'REJECTED', decided: true };
  }
  return { ...baseTimesheet };
}

export function getMockPublicTimesheet(token: string): PublicTimesheetView {
  if (!store.has(token)) store.set(token, seed(token));
  return store.get(token)!;
}

export function decideMockPublicTimesheet(token: string, approved: boolean): PublicTimesheetView {
  const current = getMockPublicTimesheet(token);
  const updated: PublicTimesheetView = {
    ...current,
    status: approved ? 'APPROVED' : 'REJECTED',
    decided: true,
  };
  store.set(token, updated);
  return updated;
}
